import { getErrorMessage } from '../util/ErrorUtils';
import axios from '../util/axiosConfig';

export const fetchScanTypesAPI = async (payload) => {    
    let params = {
        pageNo: payload.pageNo ? payload.pageNo - 1 : 0,
        pageSize: payload.pageSize,
        description: payload.description,
        cost: payload.cost,
        modalityId: payload.modalityId,
    }
    if (payload.sort) {
        params.sortKey = payload.sort.key;
        params.sortBy = payload.sort.sortBy;
    }
    return await axios.get(`/api/v1/scan-types`, { params })
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const fetchScanTypesCalendarAPI = async () => {
    return await axios.get(`/api/v1/scan-types-calendar`)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}


export const addUpdateScanTypeAPI = async (scanType) => {
    return await axios.post(`/api/v1/scan-type`, scanType)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}
